<template>
  <DatePickerFrame>
    <slot />
  </DatePickerFrame>
</template>
<script setup lang="ts">
const DatePickerFrame = defineAsyncComponent(() => {
  if (useSiteIdent() === SiteIdent.default) {
    return import('./vdv/datePickerFrame.vue');
  } else {
    return import('./minilu/datePickerFrame.vue');
  }
});
</script>
